module.exports = __webpack_public_path__ + "static/img/toujiao8.1d7275a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao8.jpg
// module id = P1Ll
// module chunks = 1